import React, { useState } from 'react';
import { signInWithEmailAndPassword, createUserWithEmailAndPassword } from 'firebase/auth';
import Accordion from 'react-bootstrap/Accordion';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Carousel } from 'react-bootstrap';


import './LoginForm.css';

function LoginForm({ auth, setLoggedIn }) {
  const [isLogin, setIsLogin] = useState(true);
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const toggleForm = () => {
    setIsLogin(!isLogin);
    setError(null);
  };

  const handleLogin = async (event) => {
    event.preventDefault();
    setLoading(true);
    setError(null);

    try {
      await signInWithEmailAndPassword(auth, email, password);
      setLoggedIn(true);
    } catch (error) {
      setError(error);
    }

    setLoading(false);
  };

  const handleSignup = async (event) => {
    event.preventDefault();
    setLoading(true);
    setError(null);

    try {
      await createUserWithEmailAndPassword(auth, email, password);
      setLoggedIn(true);
    } catch (error) {
      setError(error);
    }

    setLoading(false);
  };

  return (
    <div className="login-form-container">
      <h1>Htrend</h1>
      <form onSubmit={isLogin ? handleLogin : handleSignup}>
        <input
          type="email"
          placeholder="이메일"
          value={email}
          onChange={(event) => setEmail(event.target.value)}
          required
        />
        <input
          type="password"
          placeholder="비밀번호"
          value={password}
          onChange={(event) => setPassword(event.target.value)}
          required
        />
        <button type="submit" disabled={loading}>
          {isLogin ? (loading ? '로그인 중...' : '로그인') : (loading ? '회원가입 중...' : '회원가입')}
        </button>
        {error && (
          <div className="error-message">
            {error.code === 'auth/email-already-in-use'
              ? '이미 사용 중인 이메일입니다.'
              : '실패했습니다. 다시 시도해주세요.'}
          </div>
        )}
      </form>
      <div className="toggle-form-message">
        {isLogin ? (
          <>
            계정이 없으신가요? <span onClick={toggleForm}>회원가입</span>
          </>
        ) : (
          <>
            계정이 이미 있으신가요? <span onClick={toggleForm}>로그인</span>
          </>
        )}
            {/* <Accordion defaultActiveKey="0" flush>
      <Accordion.Item eventKey="0">
        <Accordion.Header>공지사항</Accordion.Header>
        <Accordion.Body>
        <h3>2023년 03월 11일</h3>
          - 마이페이지 들어갔다 나오면 검색 내역 사라지는 버그 Fix<br/> 
          - 구독자 필터링 기능 추가<br/> 
          - 게시글 업로드 날짜 추가<br/> 
        </Accordion.Body>
      </Accordion.Item>
    </Accordion> */}
      <Carousel>
      <Carousel.Item>
        <img
          className="d-block w-100"
          src="https://via.placeholder.com/800x400/000000/000000?text= "
        />
        <Carousel.Caption>
        <a href="https://open.kakao.com/o/gBP4S28e" target="_blank"><h3>오픈채팅방</h3></a>
          <p>더 다양한 사용법<br/> 정보등을 들을 수 있습니다</p>
        </Carousel.Caption>
      </Carousel.Item>
    </Carousel>
      </div>
    </div>
  );
}

export default LoginForm;
